var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.cameras),function(camera){return _c('LinkAnprCameraItem',{key:camera.exid,attrs:{"value":camera},on:{"change":_vm.updateCameraItem}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }